export default "__VITE_ASSET__b6888893__"